export const environment = {
  appId: 'rw3-web-admin',
  envName: 'prod',
  production: true,
  rw3apiURL: 'https://fusion.endnote.com/api-ipa/',
  pendoApiKey: '78613366-2b51-4506-ae43-88ea15d0a1f2'
};
